<template>
  <span class="editor-info-content-wrapper">
    <span v-if="!editing" class="editor-info-content">
      <span class="editor-info-content-text" v-text="text"></span>
    </span>
    <span v-else class="editor-info-content editing">
      <span>
        <EditorContentEditable
          tag="span"
          class="editor-info-content-text editing"
          contenteditable
          placeholder="Текст сноски"
          :text="text"
          @input="handleInput"
        />
      </span>
      <span>
        <EditorEditButton icon="editor/apply" @click="handleApplyClick" />
        <EditorEditButton icon="editor/delete" @click="emit('delete')" />
      </span>
    </span>
  </span>
</template>

<script setup>
const props = defineProps({
  text: { type: [String, Number], default: '' },
  editing: { type: Boolean, default: false },
});
const emit = defineEmits(['input', 'change', 'delete']);

const localText = ref('');

watch(
  props.text,
  (value) => {
    localText.value = value;
  },
  { immediate: true },
);

watch(props.editing, (value) => {
  if (!value) {
    localText.value = props.text;
  }
});

const handleInput = (e) => {
  localText.value = e.target.innerText;
  emit('input'); // from getPosition
};

const handleApplyClick = () => {
  emit('change', localText.value);
};
</script>
